// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-944274da]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.app-container[data-v-944274da] {\n  padding: 20px;\n}\n.filter-container[data-v-944274da] {\n  margin-bottom: 20px;\n}\n.filter-container .filter-item[data-v-944274da] {\n  margin-right: 10px;\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
